@if (dynamicsInitialized) {
  <div>
    <div style="width: 100%; padding: 20px" fxLayout="column" fxLayoutAlign="start start">
      <div>
        <app-video-link style="position: fixed; top: -10px; width: 50px; height: 50px" videoLink="/help/sign_scheduler"></app-video-link>
        <button style="position: relative; left: 20px" [disabled]="disableMode" color="warn" mat-flat-button (click)="jumpToSchedulers()">
          <mat-icon>link</mat-icon>
          {{ 'general.jumpToSchedulers' | transloco }}
        </button>
      </div>
      <div  style="padding: 15px">
        <form class="maxWidthArea" [formGroup]="formScheduleProps">
          <div fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="start center">
              <mat-form-field>
                <mat-label>{{ 'general.schedulers' | transloco }}</mat-label>
                <mat-select formControlName="schedule_name" (selectionChange)="selectSchedulerId($event)">
                  @for (schedulers of schedulers; track schedulers) {
                    <mat-option [value]="schedulers">{{ schedulers.schedule_name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <button matTooltip="{{'general.newScheduler' | transloco}}" mat-flat-button (click)="createNewScheduler()">
                <mat-icon style="font-size: 24px; width: 30px; height: 30px">post_add</mat-icon>
              </button>
            </div>
            <div>
              <mat-form-field style="position: relative; left: -20px" class="textarea">
                <mat-label>{{ 'placeholder.description' | transloco }}</mat-label>
                <textarea rows="8" matInput appearance="fill"
                  [disabled]="disableMode"
                  (change)="changeDescription($event)"
                  inputrestriction="basic1"
                  formControlName="description"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="8"
                cdkAutosizeMaxRows="8"></textarea>
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>
      <dynamic-form
        [fields]="uiConfigInit"
        [ignoreValidation]="true"
        (submit)="submit($event)">
      </dynamic-form>
    </div>
  </div>
}


